module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/paypay-837745691d4da3a4ceea1d8940ccf1a2.svg";